import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  //{ path: '', redirectTo: 'tutorial', pathMatch: 'full' },

  { path: 'cards', loadChildren: './pages/cards/cards.module#CardsPageModule' },
  { path: 'content', loadChildren: './pages/content/content.module#ContentPageModule' },
  { path: 'list-master', loadChildren: './pages/list-master/list-master.module#ListMasterPageModule' },
  { path: 'tutorial', loadChildren: './pages/tutorial/tutorial.module#TutorialPageModule' },
  { path: 'welcome', loadChildren: './pages/welcome/welcome.module#WelcomePageModule' },
  { path: 'login', loadChildren: './pages/login/login.module#LoginPageModule' },
  { path: 'signup', loadChildren: './pages/signup/signup.module#SignupPageModule' },
  { path: 'search', loadChildren: './pages/search/search.module#SearchPageModule' },
  { path: 'settings', loadChildren: './pages/settings/settings.module#SettingsPageModule' },
  { path: 'home', loadChildren: './pages/home/home.module#HomePageModule' },
  { 
    path: 'detail/:type/:id', 
    loadChildren: './pages/detail/detail.module#DetailPageModule' ,
  },
  { 
    path: 'detail/:type/:id/:isTagSearch', 
    loadChildren: './pages/detail/detail.module#DetailPageModule',
  },
  { 
    path: 'detail/:type/:id/suggested/:raccomandationMethod/:raccomandationRank', 
    loadChildren: './pages/detail/detail.module#DetailPageModule',
  },
  { path: 'events', loadChildren: './pages/events/events.module#EventsPageModule' },
  { path: 'events/:searchKey', loadChildren: './pages/events/events.module#EventsPageModule' },

  { path: 'events/categories/:categoryKey', loadChildren: './pages/events/events.module#EventsPageModule' },


  
  { path: 'menu/pois-list/:type', loadChildren: './pages/pois-list/pois-list.module#PoisListPageModule' },
  { path: 'menu/pois-list/:type/:categoryKey', loadChildren: './pages/pois-list/pois-list.module#PoisListPageModule' },
  
  { path: 'city-list', loadChildren: './pages/city-list/city-list.module#CityListPageModule' },
  { path: 'itinerary-list', loadChildren: './pages/itinerary-list/itinerary-list.module#ItineraryListPageModule' },

  { path: 'city/pois-list/tag/:tagSearch', loadChildren: './pages/pois-list/pois-list.module#PoisListPageModule' },
  { path: 'city/pois-list/:cityId', loadChildren: './pages/pois-list/pois-list.module#PoisListPageModule' },
  { path: 'tag/pois-list/:tag', loadChildren: './pages/pois-list/pois-list.module#PoisListPageModule' },

  { path: 'pois-list',                loadChildren: './pages/pois-list/pois-list.module#PoisListPageModule' },
  { path: 'pois-list/:type',          loadChildren: './pages/pois-list/pois-list.module#PoisListPageModule' },
  { path: 'pois-list/:type/:nearId',  loadChildren: './pages/pois-list/pois-list.module#PoisListPageModule' },
  { path: 'pois-list/:type/:nearId/:searchKey', loadChildren: './pages/pois-list/pois-list.module#PoisListPageModule' },
  { path: 'pois-list/:type/:nearId/tag/:tagKey/:tagLabel', loadChildren: './pages/pois-list/pois-list.module#PoisListPageModule' },

  { path: 'maps-search', loadChildren: './pages/maps-search/maps-search.module#MapsSearchPageModule' },

  { path: 'list', loadChildren: './pages/list/list.module#ListPageModule' },
  { path: 'profile', loadChildren: './pages/profile/profile.module#ProfilePageModule' },
  { path: 'logout', loadChildren: './pages/logout/logout.module#LogoutPageModule' },
  { path: 'favourites-list', loadChildren: './pages/favourites-list/favourites-list.module#FavouritesListPageModule' },
  { path: 'itineraries-list', loadChildren: './pages/itineraries-list/itineraries-list.module#ItinerariesListPageModule' },
  { path: 'itineraries-list/:categoryKey', loadChildren: './pages/itineraries-list/itineraries-list.module#ItinerariesListPageModule' },
  { path: 'generic-content/:contentId', loadChildren: './pages/generic-content/generic-content.module#GenericContentPageModule' },
  { path: 'last-minute', loadChildren: './pages/last-minute/last-minute.module#LastMinutePageModule' },
  { path: 'last-minute/:classification', loadChildren: './pages/last-minute/last-minute.module#LastMinutePageModule' },
  { path: 'last-minute-detail/:lastMinuteId', loadChildren: './pages/last-minute-detail/last-minute-detail.module#LastMinuteDetailPageModule' },

  { path: 'callback', loadChildren: './pages/callback/callback.module#CallbackPageModule' },

  { path: '**', loadChildren: './pages/page-not-found/page-not-found.module#PageNotFoundPageModule' },

 

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { 
      preloadingStrategy: PreloadAllModules, 
      onSameUrlNavigation: 'reload',
    })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
